import React, { useEffect } from "react";

// context
import { useSiteHeader } from "core/SiteHeader/context/useSiteHeader.js";

// hooks
import useApiStatus from "frontend/hooks/useApiStatus";

// components
import AuthMenu from "./AuthMenu";

// data
import {
    getAuthAccountLinks,
    getAuthCreatorToolsLinks,
    getAuthAdminMenu
} from "data/links";

export const ACCOUNT_TEST_ID = "account-menu-links";
export const CREATOR_TOOLS_TEST_ID = "creator-tools-menu-links";
export const ADMIN_TEST_ID = "admin-menu-links";

// component
const AuthMenus = () => {
    const { currentUser, authMenuVisibilitiy } = useSiteHeader();
    const { showAdmin, firstActiveTeam, creatorTools } = authMenuVisibilitiy;
    const { hasApiKey, getApiKeyStatus } = useApiStatus();

    /**
     * We removed hasApiKey from main user query
     * We now query for user's API key status only when they open the profile menu, as a specific call.
     */
    useEffect(() => {
        if (currentUser && hasApiKey === null) {
            getApiKeyStatus();
        }
    }, [currentUser]);

    // rendering
    if (!currentUser) return null;
    const { showMenu: showCreatorMenu, showIcons, showPhotos } = creatorTools;

    return (
        <>
            <AuthMenu
                id={ACCOUNT_TEST_ID}
                menu={getAuthAccountLinks({
                    currentUser,
                    firstActiveTeam,
                    hasApiKey
                })}
            />
            {showCreatorMenu && (
                <AuthMenu
                    id={CREATOR_TOOLS_TEST_ID}
                    menu={getAuthCreatorToolsLinks({
                        currentUser,
                        showIcons,
                        showPhotos
                    })}
                />
            )}
            {showAdmin && (
                <AuthMenu id={ADMIN_TEST_ID} menu={getAuthAdminMenu()} />
            )}
        </>
    );
};

export default AuthMenus;
